"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mindItem = (sdk) => {
    const { sdkConfig: { url }, defaultVersion } = sdk;
    const httpClient = sdk.httpClient;
    return {
        downloadInformation: async (mindItemId, trackingInfo) => {
            const endpoint = `${url}/${defaultVersion}/mindItems/${mindItemId}/downloadInformation`;
            const result = await httpClient.get(endpoint, {
                query: Object.assign({}, trackingInfo),
            });
            return result.data;
        },
        getMindItem: async (id) => {
            const endpoint = `${url}/v4/mindItems/${id}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getMindItemToken: async (id) => {
            const endpoint = `${url}/v4/mindItems/${id}/documentToken`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getMindItemSiblings: async (id) => {
            const endpoint = `${url}/v4/mindItems/${id}/siblings`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getPublicMindItem: async (accessToken) => {
            const endpoint = `${url}/v4/mindItems/public/${accessToken}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        createPublicMindItemLink: async (id) => {
            const endpoint = `${url}/v4/mindItems/${id}/publicLink`;
            const result = await httpClient.post(endpoint);
            return result.data;
        },
        getTopics: async (subject) => {
            const endpoint = `${url}/v4/mindItems/topics`;
            const result = await httpClient.get(endpoint, { query: { subject } });
            return result.data;
        },
        manageItemInMultipleCollections: async (mindItemId, payload) => {
            const endpoint = `${url}/${defaultVersion}/mindItems/${mindItemId}/manageItemInMultipleCollections`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        pinMindItem: async (mindItemId) => {
            const endpoint = `${url}/v4/mindItems/${mindItemId}/pin`;
            const result = await httpClient.put(endpoint);
            return result.data;
        },
        unpinMindItem: async (mindItemId) => {
            const endpoint = `${url}/v4/mindItems/${mindItemId}/unpin`;
            await httpClient.put(endpoint);
            return;
        },
        search: async (searchParams, abortSignal) => {
            const endpoint = `${url}/v4/mindItems/search`;
            const result = await httpClient.get(endpoint, { query: searchParams, abortSignal });
            return result;
        },
        searchSuggestions: async (searchTerm, contentType, abortSignal) => {
            const endpoint = `${url}/${defaultVersion}/mindItems/search/suggestions`;
            const query = { term: searchTerm };
            if (contentType === null || contentType === void 0 ? void 0 : contentType.length) {
                query.contentType = contentType;
            }
            const result = await httpClient.get(endpoint, { auth: false, query, abortSignal });
            return result.data;
        }
    };
};
exports.default = mindItem;
